<script>
export default {
  name: "ExplainedLinkListItem",
  props: {
    to: String,
    title: String,
    description: String
  }
}
</script>

<template>
  <router-link tag="div" class="list-group-item list-group-item-action" :to="{name: to}">
    <div class="font-weight-bold">{{title}}</div>
    <div class="text-secondary">{{description}}</div>
  </router-link>
</template>

<style scoped>

</style>